import React from "react"

const MemberImage = ({ image, alt }) => {
  return (
    <img className="rounded" src={image} alt={alt} />
  )
}

export default MemberImage
